// extracted by mini-css-extract-plugin
export default {"btn":"toggle-button_btn__9cp+A"};